const PUBLIC_TINGS_STORAGE_KEY = 'publicTingsDB';

const getFeedPath = (basePath) => {
  const source = new URLSearchParams(window.location.search).get('source');

  if (!source) {
    return basePath;
  }

  return `${basePath}?source=${encodeURIComponent(source)}`;
};

const fetchJson = async (path) => {
  const response = await fetch(path, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    credentials: 'same-origin',
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }

  return response.json();
};

export const fetchPublicMapFeed = async () => {
  const data = await fetchJson(getFeedPath('/api/map-feed'));
  const storedPosts = Array.isArray(data.tings) ? data.tings : [];

  window.localStorage.setItem(
    PUBLIC_TINGS_STORAGE_KEY,
    JSON.stringify(storedPosts),
  );

  return {
    storedPosts,
    loaded: false,
  };
};

export const fetchPublicWidgetFeed = async () => {
  const data = await fetchJson(getFeedPath('/api/widget-feed'));
  return Array.isArray(data.sightings) ? data.sightings : [];
};

export const getStoredPublicMapFeed = () => {
  return window.localStorage.getItem(PUBLIC_TINGS_STORAGE_KEY);
};

export const clearStoredPublicMapFeed = () => {
  window.localStorage.removeItem(PUBLIC_TINGS_STORAGE_KEY);
};
